const filterBrandsHandler = ( input ) => {
    const inputContainer = input.closest( 'details' );
    const selected = input.checked;
    if ( selected ) {
        moveBrandtoSelected( inputContainer );
    } else {
        moveBrandtoUnselected( inputContainer );
    }
};

const moveBrandtoSelected = ( brandElem ) => {
    const selectedBrandsContainer = document.querySelector( '.js-selected-brands' );
    insertBrandAlphabetically( brandElem, selectedBrandsContainer );
};

const moveBrandtoUnselected = ( brandElem ) => {
    const unselectedBrandsContainer = document.querySelector( '.js-filter-brand-result' );
    insertBrandAlphabetically( brandElem, unselectedBrandsContainer );
};

const insertBrandAlphabetically = ( brandElem, parentContainer ) => {
    const brands = parentContainer.querySelectorAll( 'details' );
    const brandName = brandElem.querySelector( 'input' ).value;
    let inserted = false;
    // When there are no other brands, append it directty
    if ( brands.length === 0 ) {
        parentContainer.appendChild( brandElem );
    } else {
        for ( let i = 0; i < brands.length && !inserted; i++ ) {
            const currentBrandName = brands[ i ].querySelector( 'input' ).value;
            if ( currentBrandName > brandName) {
                brands[i].insertAdjacentElement( 'beforebegin', brandElem );
                inserted = true;
            }
        }
        // Last elem will never have a sibling to compare, insert it after de last elem
        if ( !inserted ) {
            parentContainer.appendChild( brandElem );
        }
    }
};

const isBrandSelected = ( brandValue ) => {
    const selectedBrands = document.querySelectorAll( '.js-selected-brands [name="brand[]"]' );
    const selectedValues = Array.from( selectedBrands, brand => brand.value );

    return selectedValues.includes( brandValue );
}

const addTextSearchedBrandsToSelected = () => {
    document.querySelectorAll( '#filter-mobile-form .js-filter-brand-result input:checked' ).forEach( input => {
        const brandElem = input.closest( 'details' );
        const selectedBrandsContainer = document.querySelector( '.js-selected-brands' );
        insertBrandAlphabetically( brandElem, selectedBrandsContainer );
    } );
};

export { filterBrandsHandler, moveBrandtoUnselected, isBrandSelected, addTextSearchedBrandsToSelected };